import React from "react";
import { PageHero } from "../components/pageHero";
import { Stats } from "../components/stats";
import { Cta } from "../components/cta";

const About = ({ data }) => {
  const page = data.AboutPage;
  const intro = page.intro;
  const quarries = page.quarries;
  const factory = page.factory;

  return (
    <>
      <PageHero
        title={page.heroTitle}
        subtitle={page.heroSubtitle}
        image="img/hero-about.jpg"
      />

      <div className="page-section" id="story">
        <div className="container">
          <div className="row vcenter">
            <div className="col-md-6">
              <span className="eyebrow dark">Who We Are</span>
              <h2>{intro.title}</h2>
              {intro.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <div className="col-md-6">
              <img src={intro.image} className="img-responsive framed" alt="Quarry site and block yard in Oman" />
            </div>
          </div>
        </div>
      </div>

      <Stats data={data.Stats} />

      <div className="page-section alt" id="quarries">
        <div className="container">
          <div className="row vcenter">
            <div className="col-md-6">
              <img src={quarries.image} className="img-responsive framed" alt="Marble quarry bench worked with diamond wire" />
            </div>
            <div className="col-md-6">
              <span className="eyebrow dark">Extraction</span>
              <h2>{quarries.title}</h2>
              {quarries.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="check-list">
                {quarries.points.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="page-section" id="factory">
        <div className="container">
          <div className="row vcenter">
            <div className="col-md-6">
              <span className="eyebrow dark">Processing</span>
              <h2>{factory.title}</h2>
              {factory.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <div className="col-md-6">
              <img src={factory.image} className="img-responsive framed" alt="Slab hall at the International Rocks factory in Barka" />
            </div>
          </div>

          <div className="row equipment-row">
            <div className="col-md-7">
              <h3>Plant &amp; Equipment</h3>
              <ul className="check-list two-col">
                {factory.equipment.map((e, i) => (
                  <li key={i}>{e}</li>
                ))}
              </ul>
            </div>
            <div className="col-md-5">
              <img src={factory.image2} className="img-responsive framed" alt="Overhead gantry crane handling marble blocks" />
            </div>
          </div>
        </div>
      </div>

      <div className="page-section alt values-section">
        <div className="container">
          <div className="col-md-10 col-md-offset-1 section-title text-center">
            <h2>How We Work</h2>
          </div>
          <div className="card-grid cols-4">
            {page.values.map((v, i) => (
              <div key={i} className="value-item">
                <i className={v.icon}></i>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="page-section" id="registration">
        <div className="container">
          <div className="col-md-10 col-md-offset-1">
            <div className="section-title text-center">
              <h2>{page.registration.title}</h2>
              <p>{page.registration.note}</p>
            </div>
            <div className="reg-table">
              {page.registration.items.map((item, i) => (
                <div key={i} className="reg-row">
                  <span className="reg-label">{item.label}</span>
                  <span className="reg-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Cta
        title="Come and see the stone"
        text="Buyers are welcome at the Barka factory and, by appointment, at the quarry face. Tell us when you are in Oman and we will arrange the visit."
        buttonLabel="Arrange a Visit"
      />
    </>
  );
};

export default About;
